// extracted by mini-css-extract-plugin
export default {"table":"DataProject_table__5Gbh3"};